export enum UserTicketStatusEnum {
    ACTIVE = 1,
    PASSED = 2,
    FAILED = 3,

    PENDING = 10,
}
